import {
  Directive,
  Renderer2,
  ElementRef,
  HostListener,
  Output,
  EventEmitter,
} from '@angular/core';
import { format } from 'rut.js';

@Directive({
  selector: '[appRutFormatterV2]',
})
export class RutFormatterV2Directive {
  @Output() valueChange = new EventEmitter();
  constructor(public renderer: Renderer2, public el: ElementRef) {}

  @HostListener('input', ['$event.target.value']) onInput(e: string) {
    this.format(e);
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    event.preventDefault();
    this.format(event?.clipboardData?.getData('text/plain') || '');
  }

  format(val: string) {
    let result = format(val);
    // this.renderer.setProperty(this.el.nativeElement, 'value', result);
    this.valueChange.emit(result);
  }
}
